import { Directive, Input } from '@angular/core';

// libs

@Directive()
export abstract class CardBaseComponent {
  @Input() className?: string;
}
